export function dehydrate({
  pk,
  entry,
  requestedBy,
  dateRequested,
  approvedBy,
  dateApproved,
  dateCompleted,
  doi,
  pdf,
  url,
  stage,
  isOutdated,
}) {
  return {
    pk,
    entry,
    requestedBy,
    dateRequested,
    approvedBy,
    dateApproved,
    dateCompleted,
    doi,
    pdf,
    url,
    isOutdated,
    stage: dehydrateStage(stage),
  }
}

function dehydrateStage(stage) {
  switch (stage) {
    case 1:
      return 'requested'
    case 2:
      return 'approved'
    default:
      return 'completed'
  }
}
